/* AFS7 - vaste afrekenbalk onderin het uitschuifmandje.

   Waarom
   ------
   In de lade stond de Checkout-knop onderaan de samenvatting, onder het
   tweede-fles-aanbod, het cadeau en de cross-sells. Gemeten op een iPhone
   (12 okt 2026): knop op 1.522px, 775px in beeld. Vanaf de startpagina ging
   13% van de mandjes door naar de checkout, op de oude productpagina 44%.

   Hoe
   ---
   Dit bestand raakt afs7-drawer.js en de cartsectie NIET aan. Het hangt een
   balk aan het bestaande paneel (.afs7-dw__panel) en leest wat er in de lade
   staat. De knop in de balk drukt op de ECHTE afrekenknop van het mandje
   (requestSubmit met die knop als submitter), dus het formulier, kortingen,
   abonnementen en het cadeau gaan precies zoals voorheen mee.

   De knop in de samenvatting wordt pas verborgen als de balk er staat
   (klasse has-foot op het paneel). Faalt dit script, dan blijft alles zoals het was.

   Valkuilen
   ---------
   - De lade vult zichzelf met innerHTML en cartfix vervangt de sectie na elke
     wijziging. Daarom een MutationObserver op de body van de lade, met een
     korte vertraging, in plaats van luisteren naar losse events.
   - Lees het bedrag van de echte knop ("Checkout · €75,00"): die rekent het
     thema al goed uit in de valuta van de klant. Niets zelf omrekenen.
   - Een abonnement vraagt Shopify's toestemmingstekst bij de afrekenknop. De
     volledige tekst blijft in de samenvatting staan; de balk noemt het kort en
     springt er met "View terms" naartoe. */
(function () {
  'use strict';
  if (window.__afs7Foot) return;
  window.__afs7Foot = true;

  var T = window.__afs7FootText || {};
  var panel, body, foot, els = {}, timer, seq = 0;

  function q(s, r) { return (r || document).querySelector(s); }

  function make() {
    foot = document.createElement('div');
    foot.className = 'afs7-dw__foot';
    foot.hidden = true;
    foot.innerHTML =
      '<div class="afs7-dw__foot-r"><span class="afs7-dw__foot-l"></span><span class="afs7-dw__foot-v"></span></div>' +
      '<p class="afs7-dw__foot-g"><span class="afs7-dw__foot-ck" aria-hidden="true">✓</span><span class="afs7-dw__foot-gt"></span></p>' +
      '<p class="afs7-dw__foot-sub" hidden><span class="afs7-dw__foot-subt"></span> <button type="button" class="afs7-dw__foot-subl"></button></p>' +
      '<button type="button" class="afs7-dw__foot-btn"></button>' +
      '<span class="afs7-dw__foot-s"></span>';
    els.l = q('.afs7-dw__foot-l', foot);
    els.v = q('.afs7-dw__foot-v', foot);
    els.g = q('.afs7-dw__foot-g', foot);
    els.gt = q('.afs7-dw__foot-gt', foot);
    els.sub = q('.afs7-dw__foot-sub', foot);
    els.subt = q('.afs7-dw__foot-subt', foot);
    els.subl = q('.afs7-dw__foot-subl', foot);
    els.btn = q('.afs7-dw__foot-btn', foot);
    els.s = q('.afs7-dw__foot-s', foot);
    els.l.textContent = T.total || 'Total';
    els.btn.textContent = T.button || 'Checkout';
    els.s.textContent = T.note || '';
    els.s.hidden = !T.note;
    els.subt.textContent = T.sub || '';
    els.subl.textContent = T.subLink || 'View terms';

    els.btn.addEventListener('click', checkout);
    els.subl.addEventListener('click', function () {
      var c = body && q('#shopify-buyer-consent, .afs7-consent, .afs2k-sum', body);
      if (c) c.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    panel.appendChild(foot);
  }

  function realButton() { return body && q('[name="checkout"]', body); }

  function checkout() {
    var b = realButton();
    if (!b) { window.location.href = '/checkout'; return; }
    els.btn.disabled = true;
    els.btn.classList.add('is-busy');
    var f = b.form || (b.getAttribute('form') && document.getElementById(b.getAttribute('form')));
    try {
      if (f && f.requestSubmit) f.requestSubmit(b); else b.click();
    } catch (e) { b.click(); }
    // Mocht de navigatie niet doorgaan (bijv. validatie), dan de knop weer vrijgeven.
    setTimeout(function () { els.btn.disabled = false; els.btn.classList.remove('is-busy'); }, 6000);
  }

  function amountFrom(b) {
    var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
    var i = t.lastIndexOf('·');
    return i > -1 ? t.slice(i + 1).trim() : '';
  }

  function giftText(n) {
    if (n >= 2) return T.gift2 || T.gift1 || '';
    if (n === 1) return T.gift1 || '';
    return T.nogift || '';
  }

  function setGift(n) {
    var t = giftText(n);
    els.gt.textContent = t;
    els.g.hidden = !t;
  }

  /* Uit de lade zelf: snel, werkt altijd. Cadeauregels zeggen
     "Added automatically to this order" en hebben geen aantal-knoppen. */
  function domGifts() {
    var n = 0;
    body.querySelectorAll('.afs2k-line').forEach(function (l) {
      var txt = l.textContent || '';
      if (/vitamin/i.test(txt) && !q('.afs2k-line__ctl input, .afs2k-line__ctl button', l) && /free/i.test(txt)) n++;
    });
    return n;
  }
  function domSub() {
    return !!q('#shopify-buyer-consent, .afs7-consent, .afs7-subtag', body);
  }

  function update() {
    if (!panel || !body) return;
    var b = realButton();
    if (!b) { foot.hidden = true; panel.classList.remove('has-foot'); return; }
    els.v.textContent = amountFrom(b);
    setGift(domGifts());
    var sub = domSub();
    els.sub.hidden = !(sub && T.sub);
    foot.hidden = false;
    panel.classList.add('has-foot');

    // Nauwkeuriger uit /cart.js: echte aantallen en abonnementen.
    var my = ++seq;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || my !== seq || !c.items) return;
        var gifts = 0, hasSub = false;
        c.items.forEach(function (it) {
          if (it.selling_plan_allocation) hasSub = true;
          if (it.final_line_price === 0 && /vitamin/i.test(it.product_title || '')) gifts += it.quantity;
        });
        setGift(gifts);
        els.sub.hidden = !(hasSub && T.sub);
      })
      .catch(function () {});
  }

  function soon() { clearTimeout(timer); timer = setTimeout(update, 120); }

  function attach() {
    panel = q('.afs7-dw__panel');
    body = panel && q('.afs7-dw__body', panel);
    if (!panel || !body) return false;
    make();
    new MutationObserver(soon).observe(body, { childList: true, subtree: true });
    var root = panel.closest('.afs7-dw');
    if (root) new MutationObserver(soon).observe(root, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('afs7:drawer-filled', soon);
    update();
    return true;
  }

  // De lade wordt door afs7-drawer.js gebouwd; wacht tot hij er is.
  function wait(tries) {
    if (attach()) return;
    if (tries > 0) setTimeout(function () { wait(tries - 1); }, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wait(80); }, { once: true });
  } else { wait(80); }
})();
